import { render, staticRenderFns } from "./right_bottom_chart.vue?vue&type=template&id=3db72ff9"
import script from "./right_bottom_chart.vue?vue&type=script&lang=js"
export * from "./right_bottom_chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports